import {getSession, signIn, signOut} from "next-auth/react";
import {ParentRouter} from "../services/ParentRouter";
import {myLinks} from "@/lib/routes/myLinks";

class RequestApi extends ParentRouter
{
    #router = {}

    #accessToken = null

    #language = 'en'

    #remember = false

    #axiosInstance

    constructor(axiosInstance)
    {
        super();
        this.setAccessToken()

        this.#axiosInstance = axiosInstance

        this.#initFetch()
    }

    #initFetch()
    {
        ///https://www.youtube.com/watch?v=RPl0r-Yl6pU&list=LL&index=3&t=1s
        if(typeof window !== 'undefined')
        {
            this.#axiosInstance.interceptors.response.use(
                (response) => response,
                async (error) => {
                    const prevRequest = error?.config;
                    if (this.#remember || error?.response?.status === 422){
                        if (error?.response?.status === 401 && !prevRequest?.sent) {
                            prevRequest.sent = true;

                            await this.#refreshToken();
                            prevRequest.headers["Authorization"] = `Bearer ${this.#accessToken}`;
                            return this.#axiosInstance(prevRequest);
                        }
                    }else if (error?.response?.status === 401) {
                        await signOut({callbackUrl: myLinks.getUlr('sign-in')})
                    }

                    return Promise.reject(error);
                }
            )
        }
    }

    addRoute({name, url, method})
    {
        if (name && url && method){
            if (!this.#router.hasOwnProperty(name)){
                return this.#router = {
                    ...this.#router,
                    [name]: {
                        name,
                        url,
                        method,
                    }
                }
            }
            throw new Error(`Ключ у роута должен быть уникальным ${name}`)
        }
        throw new Error(`Укажите все параметры`)
    }

    async send({route, data, headers})
    {
        return this.#getAxiosInstance({route, data, headers})
    }

    async #getAxiosInstance({route: {name, query}, data, headers = {}})
    {
        const {url, method} = this.getRoute(name, query)

        return this.#axiosInstance.request({
            url,
            method,
            headers: {
                'Accept-Language': this.#language,
                Authorization: `Bearer ${this.#accessToken}`,
                ...headers,
            },
            [['GET', 'DELETE'].includes(method) ? "params" : "data"]: data
        })
    }

    async setAccessToken()
    {
        if (!this.#accessToken) {
            await this.#setSessionAccessToken()
        }
    }

    async #refreshToken()
    {
        const session = await getSession()

        const resp = await signIn('credentials',
            {
                type: 'refresh',
                session: JSON.stringify(session),
                redirect: false,
            }
        )

        // if ((resp.status !== 200 && resp.status !== 422) || !resp.status){
        //     await signOut({callbackUrl: myLinks.getUlr('sign-in')})
        // }

        await this.restAccessToken()
    }

    clearAccessToken()
    {
        this.#accessToken = null
    }

    async restAccessToken()
    {
       await this.#setSessionAccessToken()
    }

    async #setSessionAccessToken()
    {
        await (async () => {
            const session = await getSession()

            if (session) {
                this.#accessToken = session.accessToken
                this.#remember = session.remember === 'true'
            }
        })()
    }

    setToken(token)
    {
        return this.#accessToken = token
    }

    setLanguage(loc)
    {
        this.#language = loc
    }

    getRoute(name, query)
    {
        return this.buildQuery({...this.#findRoute(name)}, query, '\\{.*?\\}')
    }

    #findRoute(name)
    {
        if (this.#router.hasOwnProperty(name)){
            return this.#router[name]
        }

        throw new Error(`Роут не найден name = ${name}`)
    }
}

export default RequestApi